import Button from '@viking-eng/button';
import InputText from '@viking-eng/input-text';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { Field, Form, reset } from 'redux-form';

import './Search.scss';
import { ERROR_CODES, ERROR_MESSAGES, required, validBookingNumberOrEmail } from 'common/forms/Validations';
import Booking from 'components/Booking/BookingContainer';

const Search = ({ clearBookingFormData, handleSubmit, submitting }) => {
  useEffect(() => {
    clearBookingFormData();
    reset('bookings');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const LABELS = {
    BUTTON_SEARCH: 'SEARCH',
    DESCRIPTION: '',
    INPUT_EMAIL: 'Booking Number or Email',
    TITLE: 'Search For Guest Booking',
  };

  return (
    <>
      <div className="search-form-container">
        <Form className="search-form pt-3" name="bookings" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-12">{LABELS.DESCRIPTION}</div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="h5 mt-4 pb-3">{LABELS.TITLE}</div>
              <div className="row">
                <div className="search-form-input-wrapper col-5">
                  <Field
                    component={InputText}
                    errorCodes={{
                      [ERROR_CODES.BOOKING_NUMBER_INVALID]: ERROR_CODES.BOOKING_NUMBER_INVALID,
                      [ERROR_CODES.INVALID_EMAIL_FORMAT]: ERROR_CODES.INVALID_EMAIL_FORMAT,
                      [ERROR_CODES.REQUIRED]: ERROR_CODES.BOOKING_NUMBER_REQUIRED,
                    }}
                    errorMessages={ERROR_MESSAGES}
                    id="bookingNumber"
                    name="bookingNumber"
                    normalize={(value) => value.trim()}
                    placeholder={LABELS.INPUT_EMAIL}
                    validate={[required, validBookingNumberOrEmail]}
                    onChange={clearBookingFormData}
                  />
                </div>
                <div className="col-2">
                  <Button appearance="secondary-blue" attributes={{ type: 'submit' }} loading={submitting}>
                    {LABELS.BUTTON_SEARCH}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Form>
        <Booking />
      </div>
    </>
  );
};

Search.propTypes = {
  booking: PropTypes.shape({
    data: PropTypes.shape({
      passengers: PropTypes.arrayOf(PropTypes.shape({})),
      bookingId: PropTypes.string,
      cruiseID: PropTypes.string,
      cruiseName: PropTypes.string,
    }),
  }),
  clearBookingFormData: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};

Search.defaultProps = {
  booking: {},
};

export default Search;
